import { getVideoEl, setVideoEl } from "../../../store/videoStore";
import { layerStore, updateLayer } from "../layerStore";
import { LayerData } from "./layerData.model"


export class VideoLayerData extends LayerData {
  source: string
  compressed_source: string
  _needsResizing: boolean

  constructor(data?: Partial<VideoLayerData>) {
    super(data)
    this.source = data?.source || "";
    this.compressed_source = data?.compressed_source || "";
    this.type = "video"
    this._needsResizing = data?._needsResizing || !data?.size_w || !data?.size_h || false;

    if (!this.source && !this.compressed_source) console.warn(`Source is missing on video layer ${this.id}`);

    const cachedVideo = getVideoEl(this.id);

    if (!cachedVideo) {
      const video = document.createElement('video');
      video.src = this.compressed_source || this.source;
      video.crossOrigin = 'Anonymous'
      video.muted = true
      video.playsInline = true
      video.preload = 'auto'
      video.addEventListener('loadedmetadata', () => {
        if (getVideoEl(this.id) !== video) return;
        if (this._needsResizing) {
          updateLayer(this.id, 'size_w', video.videoWidth)
          updateLayer(this.id, 'size_h', video.videoHeight)
          updateLayer(this.id, '_needsResizing', false);
        }
      })

      video.addEventListener('error', () => {
        console.warn(`Failed to load video for layer ${this.id}: ${video.src}`);
      })

      video.addEventListener('canplaythrough', () => {
        layerStore.buffering = false
      })

      video.addEventListener('waiting', () => {
        layerStore.buffering = true
      })

      video.addEventListener('stalled', () => {
        layerStore.buffering = true
      })

      const checkBuffering = () => {
        if (video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA) {
          layerStore.buffering = true
        } else {
          layerStore.buffering = false
        }
      }
      window.setInterval(checkBuffering, 200)
      setVideoEl(this.id, video)
    }
  }
}
